// extracted by mini-css-extract-plugin
module.exports = {"top-logo":"index_top-logo_2F-yy","dropdown":"index_dropdown_uwEFJ","icon":"index_icon_mD8cl","title":"index_title_1FVBQ","menuIcon":"index_menuIcon_3x6cC"};